import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { CoreConfig } from './../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { CoreRoutes } from '../../Coordinator/Coordinator/CoreRoutes';
import { useRouteParams } from '../../Hooks/UseRouteParams';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { PressableButtonView } from '../Buttons/PressableButtonView';
import { AnimatedList } from '../Animations/AnimatedListView';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
export const ToastView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.toast,
    style: (theme, mediaQuery, window, props) => {
        return {
            container: Object.assign(Object.assign({ position: 'absolute', bottom: 5, left: 10, right: 10, alignItems: 'flex-start', flexDirection: 'column' }, mediaQuery.sm({
                alignItems: 'center',
            })), props.containerStyle),
            elementContainer: Object.assign({ width: window.width - 30 }, mediaQuery.sm({
                width: undefined
            })),
            toast: Object.assign(Object.assign({ width: '100%' }, mediaQuery.sm({
                maxWidth: 250
            })), { borderRadius: 4, paddingVertical: 6, paddingHorizontal: 12, margin: 5 }),
            success: {
                backgroundColor: '#D5EEDC',
            },
            warning: {
                backgroundColor: '#FFECA2',
            },
            error: {
                backgroundColor: '#FAC1BD',
            },
            successText: {
                color: '#18662F'
            },
            warningText: {
                color: '#806800'
            },
            errorText: {
                color: '#BE271D'
            },
            icon: {
                width: 25,
                height: 25
            },
            actions: {
                flexDirection: 'row',
                alignItems: 'center'
            },
            text: {
                fontSize: 14,
                lineHeight: 21
            }
        };
    }
})(({ style }) => {
    const [toasts] = useRouteParams(CoreRoutes.toast, []);
    return (_jsx(AnimatedList, { values: toasts, keyName: "id", containerStyle: style === null || style === void 0 ? void 0 : style.container, elementStyle: style === null || style === void 0 ? void 0 : style.elementContainer, render: toast => {
            var _a;
            const toastStyle = style === null || style === void 0 ? void 0 : style[toast.type];
            const toastTextStyle = style === null || style === void 0 ? void 0 : style[`${toast.type}Text`];
            return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.toast, toastStyle], children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [(!!toast.icon || !!toast.image) && (_jsx(AnimatedImageView, { image: toast.image, icon: toast.icon, containerStyle: style === null || style === void 0 ? void 0 : style.icon, resizeMode: "contain", color: toastTextStyle === null || toastTextStyle === void 0 ? void 0 : toastTextStyle.color })), _jsx(AnimatedTextView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, toastTextStyle, !toast.icon && !toast.image && !toast.interactions && { textAlign: 'center' }], children: toast.text }), toast.interactions && (_jsx(View, { style: style === null || style === void 0 ? void 0 : style.actions, children: (_a = toast.interactions) === null || _a === void 0 ? void 0 : _a.map(interaction => (_jsx(View, { style: { margin: 5 }, children: _jsx(PressableButtonView, Object.assign({}, interaction)) }, interaction.action))) }))] }), !!toast.timestamp && (_jsx(AnimatedTextView, { textStyle: Object.assign(Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.text), toastTextStyle), { textAlign: 'center' }), children: toast.timestamp }))] }));
        } }));
});
